
/**
 * @param {string} nodeName
 * @param {HTMLElement} node
 * @param {Function} createEntity
 */
export function findLinkEntity(nodeName, node, createEntity) {
	if (nodeName === 'a') {
		return createEntity('LINK', 'MUTABLE', {
			url: node.href
		});
	}
}



// WEBPACK FOOTER //
// ./lib/convert/html/finder/findLinkEntity.js